import React from 'react'
import { Field } from 'formik'
import moment from 'moment'
import PropTypes from 'prop-types'
import TimePicker from 'rc-time-picker'
import uiConstants from 'config/constants/ui'
import 'rc-time-picker/assets/index.css'
import './style.less'

const Time = ({ name }) => (
   <Field
      name={name}
      render={({ field, form }) => (
         <TimePicker
            defaultValue={field.value ? moment(field.value) : null}
            minuteStep={5}
            onChange={time => form.setFieldValue(name, time)}
            popupStyle={{ zIndex: uiConstants.zIndexes.timePicker }}
            showSecond={false}
            use12Hours
         />
      )}
   />
)

Time.propTypes = {
   name: PropTypes.string.isRequired
}

export default Time
